import React from "react";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";
import gql from "graphql-tag";
import { useQuery } from "@apollo/client";
import { LoadingPage } from "../UI";
import { SingleBusiness } from "../Business/BusinessList";
import { NewsList } from "../News";
import PageHeader from "./PageHeader";
import { prefixImageUrl } from "../utils/imageUrl";
import Card from "../UI/Card";
import CardRow from "../UI/CardRow";
import UISlider from "../UI/Slider";

const StartPageSection = styled("section")`
  display: flex;
  flex-wrap: wrap;
  padding: 2rem;
  ${(props) => props.theme.bp.below.lg} {
    padding: 1rem;
  }

  blockquote {
    font-size: 1rem;
    p {
      font-weight: bold;
    }
  }

  .card {
    .text-content {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: 100%;
    }
  }
`;

const PageContent = (props) => {
  const page = props.startpage;
  const businesses = props.businessData?.allRentable?.edges || [];

  const businessSwiperConfig = {
    slidesPerView: 4,
    breakpoints: {
      320: { slidesPerView: 1.5, spaceBetween: 16 },
      768: { slidesPerView: 2.5, spaceBetween: 16 },
      1024: { slidesPerView: 3, spaceBetween: 16 },
      1200: { slidesPerView: 4, spaceBetween: 16 },
    }
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{page.title}</title>
        <link rel="canonical" href="http://mysite.com/example" />
      </Helmet>
      {page.image.url ? <PageHeader pageData={{ ...page, image: { ...page.image, url: prefixImageUrl(page.image.url) } }} gap="0" /> : null}

      <NewsList first={8} displayMode='slider' />

      <StartPageSection>
        <CardRow>
          <Card className="green">
            <div className="text-content">
              <div className="column">
                <h1>{page.title}</h1>
              </div>
              <div className="column">
                <div dangerouslySetInnerHTML={{ __html: page.content }} />
                {page.boxSet.map((v, i) => {
                  return (
                    <div
                      key={`box-${i}`}
                      dangerouslySetInnerHTML={{ __html: v.content }}
                    />
                  );
                })}
              </div>
            </div>
          </Card>
          <Card className="image-card green">
            <img src={prefixImageUrl(page.image.url)} alt={page.title} />
          </Card>
        </CardRow>
      </StartPageSection>


      {businesses.length > 0 ? (
        <UISlider title="Lediga objekt" swiperConfig={businessSwiperConfig}>
          {businesses.map((p, i) => {
            let business = p.node;
            return (
              <SingleBusiness key={business.slug || i} post={business} isRentable={true} />
            );
          })}
          {businesses.map((p, i) => {
            let business = p.node;
            return (
              <SingleBusiness key={business.slug || i} post={business} isRentable={true} />
            );
          })}
        </UISlider>
      ) : (
        <p>Loading properties...</p>
      )}

    </div>
  );
};

const StartPage = () => {
  const first = 8;

  const { loading: pageLoading, error: pageError, data: pageData } = useQuery(query);
  const { loading: bizLoading, error: bizError, data: bizData } = useQuery(START_PROPERTIES_QUERY, {
    variables: { first },
  });

  if (pageLoading || bizLoading) return <LoadingPage />;

  if (pageError) console.error("StartPage Page Error:", pageError);
  if (bizError) console.error("StartPage Business Error:", bizError);

  return (
    <PageContent
      startpage={pageData?.startpage}
      businessData={bizData}
    />
  );
};

const query = gql`
  {
    startpage {
      headTitle
      excerpt
      headLink
      headLinkText
      title
      content
      image {
        url
      }
      boxSet {
        content
      }
    }
  }
`;

const START_PROPERTIES_QUERY = gql`
  query startPageProps($first: Int) {
    allRentable(first: $first) {
      edges {
        node {
          slug
          content
          contact {
            name
            email
            phone
          }
          firstImage {
            url
          }
          type
          space
          property {
            title
            city
            address
            zipCode
            firstImage {
              url
            }
            image(version: "business_box") {
              url
              width
              height
            }
            year
            elevator
          }
        }
      }
    }
  }
`;

export default StartPage;
